"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getCurrentCategory_1 = require("./getCurrentCategory");
var store_1 = require("../store/store");
var mobx_1 = require("mobx");
var currentSubcategory = mobx_1.computed(function () {
    var currentCategory = getCurrentCategory_1.default();
    for (var subcategoryIndex = 0; currentCategory && subcategoryIndex < currentCategory.subcategories.length; subcategoryIndex++) {
        var currentSubcategory_1 = currentCategory.subcategories[subcategoryIndex];
        if (currentSubcategory_1.key === store_1.getStore().currentSubCategoryKey) {
            return currentSubcategory_1;
        }
    }
    return {};
});
exports.default = function () { return currentSubcategory.get(); };
//# sourceMappingURL=getCurrentSubcategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/selectors/getCurrentSubcategory.js
// module id = 3769
// module chunks = 2